import React from 'react';
import { IconButton } from 'material-ui';
import ArrowDropDown from 'material-ui/svg-icons/navigation/arrow-drop-down';
import ArrowDropUp from 'material-ui/svg-icons/navigation/arrow-drop-up';
import { connect } from 'react-redux';
import Delete from 'material-ui/svg-icons/action/delete';
import moment from 'moment';
import Edit from 'material-ui/svg-icons/editor/mode-edit';
import { Link } from 'react-router-dom';
import { commitMutation, graphql } from 'react-relay';
import PropTypes from 'prop-types';

import environment from '../../relay/environment';
import OurismanTravelTheme from '../../ourismanTravelTheme';

function reorderTraveler(input) {
  commitMutation(
    environment,
    {
      mutation: graphql`
        mutation TravelerListItem_ReorderTraveler_Mutation (
          $input: ReorderTravelerInput!
        ) {
          reorderTraveler(input: $input) {
            trip {
              tripName,
              primaryTravelerName,
              travelers {
                id
              }
            }
          }
        }
      `,
      variables: { input },
      onError: err => alert(err),
    }
  );
}

@connect()
class TravelerListItem extends React.Component {
  static propTypes = {
    trip: PropTypes.shape({
      id: PropTypes.string,
    }).isRequired,
    traveler: PropTypes.shape({
      id: PropTypes.string,
    }).isRequired,
    index: PropTypes.number.isRequired,
  }

  moveUp = () => {
    const {
      trip: { id: tripId }, traveler: { id: travelerId }, index,
    } = this.props;

    reorderTraveler({
      tripId,
      travelerId,
      oldIndex: index,
      newIndex: index - 1,
    });
  }

  moveDown = () => {
    const {
      trip: { id: tripId }, traveler: { id: travelerId }, index,
    } = this.props;
    reorderTraveler({
      tripId,
      travelerId,
      oldIndex: index,
      newIndex: index + 1,
    });
  }

  remove = () => {
    const {
      trip: { id: tripId }, traveler: { id: travelerId },
    } = this.props;

    commitMutation(
      environment,
      {
        mutation: graphql`
          mutation TravelerListItem_DeleteTraveler_Mutation(
            $input: DeleteTravelerInput!
          ) {
            deleteTraveler(input: $input) {
              trip {
                travelers {
                  id
                },
                tripName,
                primaryTravelerName,
                numTravelers
              }
            }
          }
        `,
        variables: { input: { tripId, travelerId } },
        onError: err => alert(err),
      }
    );
  }

  render() {
    const {
      traveler: {
        id, firstName, lastName, primaryTravelerName, birthdate, adult,
      }, index,
    } = this.props;
    const travelerName = `${lastName}, ${firstName}`;
    const primaryTraveler = primaryTravelerName ? ` (${primaryTravelerName})` : null;

    const age = (() => {
      if (birthdate) {
        return moment().diff(moment(birthdate), 'years');
      } else if (adult) {
        return '18+';
      }

      return 'child';
    })();

    const listItemStyle = {
      ...styles.listItemStyle,
      background: index % 2 !== 0 ? OurismanTravelTheme.palette.primary3Color : '',
    };

    return (<li style={listItemStyle}>
      <div style={styles.listTravelerStyle}>
        <div><Link to={`/clients/${id}/`}>{travelerName}</Link> ({age})</div>
        {primaryTraveler ? <div style={styles.primaryTravelerStyle}>
          {primaryTraveler}
        </div> : null}
      </div>
      <div style={styles.listActionStyle}>
        <IconButton
          style={styles.buttonStyle}
          onTouchTap={this.moveUp}
        >
          <ArrowDropUp />
        </IconButton>
        <IconButton
          style={styles.buttonStyle}
          onTouchTap={this.moveDown}
        >
          <ArrowDropDown />
        </IconButton>
        <a href={`/edit/${id}/`} target='_blank' rel='noopener noreferrer'>
          <Edit />
        </a>
        <IconButton
          style={styles.buttonStyle}
          onTouchTap={this.remove}
        >
          <Delete />
        </IconButton>
      </div>
    </li>);
  }
}

const styles = {
  buttonStyle: {
    padding: 0,
    width: 20,
    height: 5,
  },
  listItemStyle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
    width: '100%',
    justifyContent: 'space-between',
  },
  listTravelerStyle: {
    flex: '2 0 content',
  },
  listActionStyle: {
    flex: '1 0 content',
    display: 'flex',
    alignItems: 'baseline',
  },
  primaryTravelerStyle: {
    color: 'grey',
    fontSize: 8,
    paddingLeft: 8,
  },
};

export default TravelerListItem;



// WEBPACK FOOTER //
// /src/components/Trips/TravelerListItem.js